import React from 'react';
import PropTypes from 'prop-types';

const OrganicShapeC = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 607 875">
      <polygon
        fill={props.color}
        points="0 299.472 493.011 0 607 394.711 493.011 875 156.628 638.309"
      />
    </svg>
  );
};

OrganicShapeC.defaultProps = {
  color: '#000000',
};

OrganicShapeC.propTypes = {
  color: PropTypes.string,
};

export default OrganicShapeC;
